/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import "react-dropzone-uploader/dist/styles.css";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useTable,
} from "react-table";
import "./filtering.css";
import CreatableSelect from "react-select/creatable";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../../services/AxiosInstance";
import CustomOption from "./CustomOption";

export const ColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  return (
    <div>
      <input
        className="form-control input-search"
        value={filterValue || ""}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
};

export const GlobalFilter = ({ filter, setFilter, children }) => {
  return (
    <div className="d-flex justify-content-between algin-items-center">
      <div>
        Search :{" "}
        <input
          type="search"
          className="ml-2 input-search form-control"
          value={filter || ""}
          onChange={(e) => setFilter(e.target.value)}
        />
      </div>
      {children}
    </div>
  );
};
const Coverage = ({ data: vendors }) => {
  const [datakey, setDataKey] = useState([]);
  const [data, setData] = useState([]);
  const [types, setTypes] = useState([]);
  const [vendorid, setVendorId] = useState(null);
  const [file, setFile] = useState(null);
  const [type, setType] = useState(null);
  const [assignedproducts, setAssignedProducts] = useState([]);
  const [perPage, setPerPage] = useState(10);
  const [pagination, setPagination] = useState(null);
  const [selectPage, setSelectPage] = useState(1);
  const [show, setShow] = useState(false);
  const [productModal, setProductModal] = useState(false);
  const [deleteShow, setDeleteShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [fieldValue, setFieldValue] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProductstype, setSelectedProductstype] = useState(null);
  const [rowId, setRowId] = useState(null);
  const [costumfilter, setCostumfilter] = useState({
    year: "",
    make: "",
    model: "",
  });

  const onShow = () => setShow(true);
  const onHide = () => setShow(false);
  const onDeleteShow = () => setDeleteShow(true);
  const onDeleteHide = () => setDeleteShow(false);
  const onEditShow = () => setEditShow(true);
  const onEditHide = () => setEditShow(false);
  const onFilterShow = () => setFilterShow(true);
  const onFilterHide = () => setFilterShow(false);
  const onProductShow = () => setProductModal(true);
  const onProductHide = () => setProductModal(false);
  const getCoverage = useCallback(() => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("vendor_id", vendorid);
    formdata.append("type", type);
    formdata.append("page", selectPage);
    formdata.append("per_page", perPage);

    axiosInstance
      .post(`get/file/by/type`, formdata)
      .then((response) => {
        if (response?.data.status === true) {
          setData(response?.data?.data[type]?.data || []);
          setDataKey(Object.keys(response?.data?.data[type]?.data?.[0] || {}));
          setPagination(response?.data?.data[type]);
          onFilterHide();
        }
        setLoader(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
      })
      .catch((error) => {
        setLoader(false);
        console.error(error);
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
  }, [vendorid, type, selectPage, perPage]);

  const COLUMNS = useMemo(() => {
    return [
      {
        Header: "Vendor Name",
        Footer: "Vendor Name",
        accessor: "vendor_id",
        Filter: ColumnFilter,
        Cell: ({ value }) => {
          const vendorName = vendors.find((s) => s.id === value);
          return <>{vendorName?.name}</>;
        },
      },
      ...datakey
        .filter(
          (s) =>
            s !== "id" &&
            s !== "created_at" &&
            s !== "updated_at" &&
            s !== "vendor_id"
        )
        .map((key) => ({
          Header: key.replace(/_/g, " "),
          Footer: key.replace(/_/g, " "),
          accessor: key,
          Filter: ColumnFilter,
        })),
      {
        Header: "Action",
        Footer: "Action",
        Cell: ({ row }) => {
          const DeleteCoverage = async (id) => {
            setLoader(true);
            try {
              const response = await axiosInstance.delete(
                `admin/del/car/coverage/${id}/${type}`
              );
              if (response.data.status === true) {
                getCoverage();
                toast.success(response.data.message);
              } else {
                toast.error("Something went wrong");
              }
            } catch (error) {
              toast.error("Something went wrong");
            } finally {
              setLoader(false);
            }
          };

          return (
            <div className="d-flex gap-2">
              <button
                onClick={() => getCoverageID(row.original.id)}
                title="Edit"
                className="btn btn-outline-success btn-sm rounded"
              >
                <i className="fa fa-pen" />
              </button>
              <button
                onClick={() => DeleteCoverage(row.original.id)}
                title="Delete"
                className="btn btn-outline-danger btn-sm rounded"
              >
                <i className="fa fa-trash" />
              </button>
              <button
                onClick={() => getAssignedProducts(row.original.id)}
                title="View Products"
                className="btn btn-outline-warning btn-sm rounded"
              >
                <i class="bi bi-bag-plus-fill" />
              </button>
            </div>
          );
        },
      },
    ];
  }, [vendors, datakey, getCoverage]);

  const tableInstance = useTable(
    {
      columns: COLUMNS,
      data,
      initialState: { pageIndex: 0 },
      filterTypes: {
        // Custom filter logic for year, make, and model
        text: (rows, columnIds, filterValue) => {
          return rows.filter((row) =>
            row.values[columnIds[0]]
              .toString()
              .toLowerCase()
              .includes(filterValue.toLowerCase())
          );
        },
      },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const handleFilterChange = (columnId, value) => {
    tableInstance.setFilter(columnId, value);
  };

  const filterOptions = (data, column) => {
    return [...new Set(data.map((row) => row[column]))];
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    setGlobalFilter,
  } = tableInstance;
  const { globalFilter } = state;

  const getCoverageID = (id) => {
    const formdata = new FormData();
    formdata.append("type", type);
    setLoader(true);
    axiosInstance
      .post(`admin/get/car/coverage/record/${id}`, formdata)
      .then((response) => {
        if (response?.data.status === true) {
          setFieldValue(response?.data?.data);
          onEditShow();
        }
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
        console.error(error);
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
  };
  const getType = () => {
    setLoader(true);
    axiosInstance
      .get("admin/get/all/types")
      .then((response) => {
        const { data } = response.data;
        setTypes(data);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to fetch years.");
        setLoader(false);
      });
  };

  const updateCoverage = (id) => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("type", type);
    for (const key in fieldValue) {
      if (Object.hasOwnProperty.call(fieldValue, key)) {
        formdata.append(key, fieldValue[key]);
      }
    }
    formdata.append("id", id);
    axiosInstance
      .post(`admin/update/car/coverage/records`, formdata)
      .then((response) => {
        if (response.data.status) {
          getCoverage();
          onEditHide();
          toast.success(response.data.message);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const fileUpload = () => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("file", file);
    // formdata.append("type", type);
    formdata.append("vendor_id", vendorid);
    axiosInstance
      .post("Admin/import/excel", formdata)
      .then((response) => {
        const { message, status } = response.data;
        if (status) {
          toast.success(message);
          getCoverage();
          onHide();
        }
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const fileDelete = () => {
    setLoader(true);
    axiosInstance
      .delete(`admin/del/vendor/file/${vendorid}`)
      .then((response) => {
        const { message, status } = response.data;
        if (status) {
          toast.success(message);
          getCoverage();
          onDeleteHide();
          setVendorId("");
        }
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };
  const getAssignedProducts = (id) => {
    setLoader(true);
    axiosInstance
      .get(`admin/get/data/by/rowId/${id}`)
      .then((response) => {
        if (response.data.status) {
          setAssignedProducts(response.data.data);
          onProductShow();
          setRowId(id);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };
  const AssignedProducts = () => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("type", type);
    formdata.append("row_id", rowId);
    formdata.append("column_name", selectedProductstype);
    selectedProducts.map((product, index) =>
      formdata.append(`assignments[${index}][product_id]`, product.value)
    );
    axiosInstance
      .post(`admin/assign/products`, formdata)
      .then((response) => {
        if (response.data.status) {
          getAssignedProducts(rowId);
          setSelectedProducts([]);
        }
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);

        console.error(error);
      });
  };
  const DeleteAssignedProducts = (id) => {
    setLoader(true);
    axiosInstance
      .delete(`admin/delete/data/by/${id}`)
      .then((response) => {
        if (response.data.status) {
          getAssignedProducts(rowId);
          toast.success(response.data.message);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };
  const getProducts = () => {
    setLoader(true);
    axiosInstance
      .get(`admin/get/products`)
      .then((response) => {
        if (response.data.status) {
          const option = response.data.data.map((pro) => ({
            label: pro.name,
            value: pro.id,
          }));
          setProducts(option);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };
  const handleCreateProduct = (inputValue) => {
    setIsLoading(true);
    var formdata = new FormData();

    formdata.append("name", inputValue);

    axiosInstance
      .post(`admin/add/product`, formdata)
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
          getProducts();
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const handleDeleteProduct = (optionToDelete) => {
    setIsLoading(true);

    axiosInstance
      .delete(`admin/del/product/${optionToDelete.value}`)
      .then((response) => {
        if (response.data.status) {
          getProducts();
          toast.success(response.data.message);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldValue({ ...fieldValue, [name]: value });
  };
  useEffect(() => {
    if (vendorid && type) {
      getCoverage(); // Trigger the API call
    }
  }, [vendorid, type]);

  // API call when selectPage or perPage changes
  useEffect(() => {
    if (vendorid && type) {
      getCoverage(); // Trigger the API call
    }
  }, [selectPage, perPage]);

  useEffect(() => {
    getType();
    getProducts();
  }, []);

  return (
    <>
      {loader && <div className="loader" />}
      <div className="card">
        <div className="card-header">
          <h4 className="card-title float-left">Car Coverage</h4>
          <div>
            <button className="btn btn-primary float-end ms-1" onClick={onShow}>
              Add Car Coverage
            </button>
            <button
              className="btn btn-primary float-end ms-1"
              onClick={onDeleteShow}
            >
              Delete Vendor File
            </button>
            <button
              className="btn btn-primary float-end"
              onClick={onFilterShow}
            >
              Filter Car Coverage
            </button>
          </div>
        </div>
        {data.length > 0 && (
          <div className="card-body">
            <div className="table-responsive">
              <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter}>
                <div className="d-flex gap-1">
                  <div>
                    Year :{" "}
                    <select
                      className="ml-2 input-search form-control"
                      value={costumfilter.year || ""}
                      onChange={(e) => {
                        setCostumfilter({
                          ...costumfilter,
                          year: e.target.value,
                        });
                        handleFilterChange("year", e.target.value); // Trigger filter
                      }}
                    >
                      <option value="">Select Year..</option>
                      {filterOptions(data, "year").map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    Make :{" "}
                    <select
                      className="ml-2 input-search form-control"
                      value={costumfilter.make || ""}
                      onChange={(e) => {
                        setCostumfilter({
                          ...costumfilter,
                          make: e.target.value,
                        });
                        handleFilterChange("make", e.target.value); // Trigger filter
                      }}
                    >
                      <option value="">Select Make..</option>
                      {filterOptions(data, "make").map((make) => (
                        <option key={make} value={make}>
                          {make}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    Model :{" "}
                    <select
                      className="ml-2 input-search form-control"
                      value={costumfilter.model || ""}
                      onChange={(e) => {
                        setCostumfilter({
                          ...costumfilter,
                          model: e.target.value,
                        });
                        handleFilterChange("model", e.target.value); // Trigger filter
                      }}
                    >
                      <option value="">Select Model..</option>
                      {filterOptions(data, "model").map((model) => (
                        <option key={model} value={model}>
                          {model}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </GlobalFilter>
              <table
                {...getTableProps()}
                id="table-to-export"
                className="table display"
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps()}>
                          {column.render("Header")}
                          {/* Render column filters if available */}
                          {/* {column.canFilter ? column.render("Filter") : null} */}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between">
              <span>
                Page{" "}
                <strong>
                  {pagination?.current_page} of {pagination?.last_page}
                </strong>
                {""}
              </span>
              <span className="table-index">
                Per Page :{" "}
                <input
                  type="number"
                  value={perPage}
                  onChange={(e) => setPerPage(e.target.value)}
                  className="ml-2"
                />
              </span>
            </div>
            <div className="text-center">
              <div className="filter-pagination  mt-3">
                <button
                  className=" previous-button"
                  disabled={selectPage === 1}
                  onClick={() => setSelectPage(1)}
                >
                  {"<<"}
                </button>

                <button
                  className="previous-button"
                  disabled={selectPage === 1}
                  onClick={() => setSelectPage(selectPage - 1)}
                >
                  Previous
                </button>
                <button
                  className="next-button"
                  onClick={() => setSelectPage(selectPage + 1)}
                >
                  Next
                </button>
                <button
                  className=" next-button"
                  onClick={() => setSelectPage(pagination?.last_page)}
                  disabled={selectPage === pagination?.last_page}
                >
                  {">>"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Modals */}
      {/* Add/Edit Modal */}
      <Modal show={show || editShow} onHide={editShow ? onEditHide : onHide}>
        <Modal.Header closeButton>
          <Modal.Title>{editShow ? "Edit" : "Add"} Car Coverage</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editShow ? (
            <div className="row">
              {datakey
                .filter(
                  (s) =>
                    s !== "id" &&
                    s !== "created_at" &&
                    s !== "updated_at" &&
                    s !== "vendor_id"
                )
                .map((key) => (
                  <div className=" col-md-6 mb-3 form-group" key={key}>
                    <label>{key.replace(/_/g, " ")}</label>
                    <input
                      type="text"
                      className="form-control"
                      name={key}
                      value={fieldValue[key] || ""}
                      onChange={handleInputChange}
                    />
                  </div>
                ))}
            </div>
          ) : (
            <>
              <div className="form-group mb-3">
                <label>Vendor Name</label>

                <select
                  className="form-control p-2"
                  onChange={(event) => setVendorId(event.target.value)}
                >
                  <option value="">Select Vendor Name....</option>
                  {vendors.map((vendor) => (
                    <>
                      <option value={vendor.id}>{vendor.name}</option>
                    </>
                  ))}
                </select>
              </div>

              <div className="form-group mb-3">
                <label>File</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={editShow ? onEditHide : onHide}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={
              editShow ? () => updateCoverage(fieldValue.id) : fileUpload
            }
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Modal */}
      <Modal show={deleteShow} onHide={onDeleteHide}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Vendor File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the vendor file?
          <div className="form-group mb-3">
            <select
              className="form-control p-2"
              onChange={(event) => setVendorId(event.target.value)}
            >
              <option value="">Select Vendor Name....</option>
              {vendors.map((vendor) => (
                <>
                  <option value={vendor.id}>{vendor.name}</option>
                </>
              ))}
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onDeleteHide}>
            No
          </Button>
          <Button variant="danger" onClick={fileDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Filter Modal */}
      <Modal show={filterShow} onHide={onFilterHide}>
        <Modal.Header closeButton>
          <Modal.Title>Filter Car Coverage</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label>Vendor</label>
            <select
              className="form-control"
              onChange={(e) => setVendorId(e.target.value)}
            >
              <option value="">Select Vendor</option>
              {vendors.map((vendor) => (
                <option key={vendor.id} value={vendor.id}>
                  {vendor.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Type</label>
            <select
              className="form-control p-2"
              onChange={(event) => setType(event.target.value)}
            >
              <option value="">Select Type....</option>
              {types.map((type) => (
                <option value={type.name}>{type.name}</option>
              ))}
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onFilterHide}>
            Close
          </Button>
          <Button variant="primary" onClick={getCoverage}>
            Filter
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Product Modal */}
      <Modal show={productModal} onHide={onProductHide}>
        <Modal.Header closeButton>
          <Modal.Title>Products</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row mb-3">
              <div className="col-md-6">
                <label>Product</label>

                <CreatableSelect
                  isClearable
                  isMulti
                  components={{ Option: CustomOption }}
                  isDisabled={isLoading}
                  isLoading={isLoading}
                  onCreateOption={handleCreateProduct}
                  onChange={setSelectedProducts}
                  onDeleteOption={handleDeleteProduct}
                  options={products}
                  value={selectedProducts}
                />
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Product Type</label>
                  <select
                    className="form-control p-2"
                    onChange={(event) =>
                      setSelectedProductstype(event.target.value)
                    }
                  >
                    <option value="">Select Product Type....</option>
                    {datakey
                      .filter(
                        (s) =>
                          s !== "id" &&
                          s !== "created_at" &&
                          s !== "updated_at" &&
                          s !== "vendor_id" &&
                          s !== "year" &&
                          s !== "make" &&
                          s !== "model" &&
                          s !== "trim"
                      )
                      .map((key) => (
                        <option value={key}>{key.replace(/_/g, " ")}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Product Name</th>
                    <th>Product Type</th>

                    <th>Action</th>
                  </tr>
                </thead>
                {assignedproducts.length > 0 && (
                  <tbody>
                    {assignedproducts.map((pro) => (
                      <tr key={pro.product.id}>
                        <td>{pro.product.name}</td>
                        <td>{pro?.column_name?.replace(/_/g, " ")}</td>

                        <td>
                          <button
                            onClick={() => DeleteAssignedProducts(pro.id)}
                            title="Delete"
                            className="btn btn-outline-danger btn-sm rounded"
                          >
                            <i className="fa fa-trash" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
            {assignedproducts.length === 0 && <p>No products found.</p>}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onProductHide}>
            Close
          </Button>
          <Button variant="primary" onClick={AssignedProducts}>
            Assign Product
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Coverage;
